module.exports = __webpack_public_path__ + "img/footer-pattern-left.337d349c.png";